import React, { useEffect } from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'

const CXonePopupCallback = () => {
  useEffect(() => {
    debugger
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    if (code) {
      const message = {
        type: 'CXONE_AUTH_SUCCESS',
        authCode: code,
      }

      window.opener.postMessage(message, window.location.origin)

      setTimeout(() => {
        window.close()
      }, 1000)
    } else {
      window.opener.postMessage(
        {
          type: 'CXONE_AUTH_ERROR',
          error: 'no_code',
          errorDescription: 'No authorization code received',
        },
        window.location.origin
      )

      window.close()
    }
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={3}
    >
      <CircularProgress size={40} sx={{ mb: 2 }} />
      <Typography variant="h6" color="primary" gutterBottom>
        Completing Authentication...
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Please wait while we complete your CXone authentication.
        <br />
        This window will close automatically.
      </Typography>
    </Box>
  )
}

export default CXonePopupCallback
